// 一覧の表頭クリックによる行のフィルター（認定講師の有無 / メイン講師の設定状況）
// 行は data-certified="1" と data-main-lecturer-undecided="1" で判定する（サーバー描画・クライアント描画とも同じ属性）

export const CERTIFIED_FILTER_STATES = ['all', 'certified', 'non-certified']
export const MAIN_LECTURER_FILTER_STATES = ['all', 'null', 'not-null']

const CERTIFIED_INDICATORS = {
    all: { text: '🔍', title: '全ての授業を表示中' },
    certified: { text: '✅', title: '認定講師が必要な授業のみ表示中' },
    'non-certified': { text: '❌', title: '認定講師が不要な授業のみ表示中' },
}

const MAIN_LECTURER_INDICATORS = {
    all: { text: '🔍', title: '全ての授業を表示中' },
    null: { text: '❌', title: 'メイン講師が未設定の授業のみ表示中' },
    'not-null': { text: '✅', title: 'メイン講師が設定済みの授業のみ表示中' },
}

/**
 * @returns {{certified: string, main: string}}
 */
export const initialFilters = () => ({ certified: 'all', main: 'all' })

/**
 * 状態を次へ進める（末尾の次は先頭）
 *
 * @param {string[]} states
 * @param {string} current
 * @returns {string}
 */
export const nextState = (states, current) => states[(states.indexOf(current) + 1) % states.length]

/**
 * 行が条件を満たすか
 *
 * @param {HTMLElement} row
 * @param {{certified: string, main: string}} filters
 * @returns {boolean}
 */
const matches = (row, filters) => {
    const isCertified = row.dataset.certified === '1'
    const hasMainLecturer = row.dataset.mainLecturerUndecided !== '1'
    const certifiedMatch = filters.certified === 'all' || (filters.certified === 'certified') === isCertified
    const mainMatch = filters.main === 'all' || (filters.main === 'not-null') === hasMainLecturer

    return certifiedMatch && mainMatch
}

/**
 * 一覧の行にフィルターを適用し、表頭のインジケーターを更新する
 *
 * @param {HTMLElement} root 一覧を含む要素
 * @param {{certified: string, main: string}} filters
 * @returns {void}
 */
export const applyFilters = (root, filters) => {
    root.querySelectorAll('tbody tr[role="row"]').forEach((row) => {
        row.style.display = matches(row, filters) ? '' : 'none'
    })

    const certifiedIndicator = root.querySelector('.js-filter-certified-indicator')
    if (certifiedIndicator) {
        certifiedIndicator.textContent = CERTIFIED_INDICATORS[filters.certified].text
        certifiedIndicator.title = CERTIFIED_INDICATORS[filters.certified].title
    }
    const mainIndicator = root.querySelector('.js-filter-main-indicator')
    if (mainIndicator) {
        mainIndicator.textContent = MAIN_LECTURER_INDICATORS[filters.main].text
        mainIndicator.title = MAIN_LECTURER_INDICATORS[filters.main].title
    }
}
